import { IconButton, Tooltip, styled } from "@mui/material";
import clsx from "clsx";
import { useAppDispatch } from "../../../redux/store";
import { IWithClassName } from "../../../theme/default.theme";
import { RunStatus } from "../enum/run-status";
import { IListBuilderTableDto } from "../interface/dto/list-builder-table-list.dto";
import { listBuilderTableBuildAction } from "../redux/list-builder-table-page.action";
interface IOwnProps {
    listBuilder: IListBuilderTableDto;
}

const ListBuilderBuild = ({
    className,
    listBuilder,
}: IWithClassName & IOwnProps) => {
    const dispatch = useAppDispatch();

    const isButtonDisabled = listBuilder
        ? [RunStatus.Pending, RunStatus.Running].includes(
              listBuilder.lastRunStatus,
          ) && listBuilder.lastRunProgress < 100
        : true;

    const handleBuildClick = () => {
        if (listBuilder) {
            dispatch(listBuilderTableBuildAction(listBuilder.listBuilderId));
        }
    };

    return (
        <span className={className}>
            <Tooltip
                title={
                    listBuilder?.lastRunStatus === RunStatus.Ready
                        ? "Rebuild List"
                        : "Build List"
                }
            >
                <span>
                    <IconButton
                        onClick={handleBuildClick}
                        aria-label="build"
                        disabled={isButtonDisabled}
                        className={clsx({ disabledButton: isButtonDisabled })}
                    >
                        <img src="/assets/build.svg" alt="Build" />
                    </IconButton>
                </span>
            </Tooltip>
        </span>
    );
};

export default styled(ListBuilderBuild)(() => ({
    ".disabledButton": {
        opacity: 0.5,
    },
}));
